import { useTranslation } from 'react-i18next'
import { Form, Input, Button, Checkbox } from 'antd'
import { useContextConsumer } from 'context/loginAuthProvider'
import { clearStroage, debounce } from 'utils'
import { useEffect, useRef, useState } from 'react'
import { getStroage, setStroage } from 'utils'
// import { useSelector } from 'react-redux'

const account = JSON.parse(getStroage('account') ?? null)

export const LoginForm = () => {
    const formRef = useRef(null)
    const { t } = useTranslation()
    const { login } = useContextConsumer()
    const [loading, setLoading] = useState(false)
    // const systemData = useSelector(state => state.AppSlice.systemData) // 系统信息

    // 前端验证
    const onFinish = values => {
        const hasUpperCase = /[A-Z]/.test(values.password)
        const hasLowerCase = /[a-z]/.test(values.password)
        const hasNumber = /\d/.test(values.password)
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(values.password)
        if (values?.password.length >= 12 && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar) {
            setStroage('password', true)
        } else {
            setStroage('password', false)
        }
        setLoading(true)
        login(values, setLoading) // 发送登录请求
    }
    const onFinishFailed = errorInfo => {}

    // 事件处理
    const onChange = e => {
        const state = e.target.checked
        if (!state) {
            clearStroage('account') // 清空本地存储
        }
    }

    /* 登录失败 */
    // useEffect(() => {
    //     if (!error) return
    //     message.error(error)
    // }, [error])

    // 动态表单回显数据
    useEffect(() => {
        formRef.current.setFieldsValue({
            username: account?.username,
            password: account?.password,
            remember: account?.remember,
        })
    }, [account])

    return (
        <Form
            className='loginForm'
            name='loginForm'
            onFinish={debounce(onFinish)}
            onFinishFailed={onFinishFailed}
            ref={formRef}
        >
            <div className='label'>{t('login.username')}</div>
            <Form.Item name='username' className='username'>
                <Input />
            </Form.Item>
            <div className='label'>{t('login.password')}</div>
            <Form.Item name='password' className='password'>
                <Input.Password />
            </Form.Item>

            <Form.Item name='remember' valuePropName='checked' className='remember'>
                <Checkbox onChange={onChange} className='text'>
                    {t('login.RememberPassword')}
                </Checkbox>
            </Form.Item>
            <Form.Item className='btn'>
                <Button type='primary' htmlType='submit' loading={loading}>
                    {t('login.button')}
                </Button>
            </Form.Item>
        </Form>
    )
}
